import { BASE_GPS_MATRIX_STAG_URL, GET_GPS_DELAY_ANALYSIS } from "../Constant";
import { getAPIPromise } from "./APIutils";

export function fetchDelayAnalysis(params) {
    const {
        vehicleNo,
        fromTimestamp,
        toTimestamp,
        regionId,
        timeZone = "Asia/Kolkata",
    } = params;

    let url = `${BASE_GPS_MATRIX_STAG_URL}${GET_GPS_DELAY_ANALYSIS}`
        + `?vehicleNo=${vehicleNo}`
        + `&fromTimestamp=${fromTimestamp}`
        + `&toTimestamp=${toTimestamp}`
        + `&regionId=${regionId}`
        + `&timeZone=${encodeURIComponent(timeZone)}`;

    return getAPIPromise(url, { method: "get" });
}
